import { booleanAttribute } from "#ce/utils/props";

// Props only the provider card declares, so a deployment default for them reaches no location card.
export const props = Object.freeze({
  /**
   * Shows the number of ratings under the stars: "45 Ratings". A deployment sets it for every provider card through its
   * `sp_components.yml` defaults.
   *
   * @type {Boolean|String}
   * @default false
   */
  showratingcount: booleanAttribute(),
  /**
   * Leaves out the rating of a result that has none, in place of the not-rated text. A deployment sets it for
   * every card through its `sp_components.yml` defaults.
   *
   * @type {Boolean|String}
   * @default false
   */
  hideunratedrating: booleanAttribute(),
});
